import {Component, Input, ViewEncapsulation} from '@angular/core';
import {register} from 'swiper/element/bundle';
import {FileViewerManagerService} from '../../../Services/Shared/file-viewer-manager.service';

register();

@Component({
  selector: 'app-image-banner-swiper',
  templateUrl: './image-banner-swiper.component.html',
  styleUrls: ['./image-banner-swiper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ImageBannerSwiperComponent {

  @Input() images: string[] = [];

  constructor(
    protected fileViewerManager: FileViewerManagerService,
  ) {
  }


  /**
   * Abrir imagen
   *
   */
  openImage(image: string) {

    if (!image) {
      return;
    }

    this.fileViewerManager.openFile(image);
  }

}
